import { http } from '@/services/api/client';
import type { LeadershipReportsBundle, QueryLeadershipReportsParams } from '@/types/leadership-report';

export async function fetchLeadershipReports(
  params: QueryLeadershipReportsParams,
): Promise<LeadershipReportsBundle> {
  return http.get('/reports/leadership', { params }) as Promise<LeadershipReportsBundle>;
}
